import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5efd318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about textured-background" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"content\" data-v-d5efd318><p data-v-d5efd318> Il collettivo <span class=\"bolder\" data-v-d5efd318>DIRTY SÖCKS</span> nasce nel febbraio 2021 sull’asse <span class=\"bolder\" data-v-d5efd318>Bologna-Napoli-Avellino.</span></p><p data-v-d5efd318> Il gruppo, che riunisce al suo interno musicisti e visual artist, approda sul pianeta SoundCloud con i primi lavori indipendenti, per poi uscire su Spotify con il singolo <span class=\"bolder\" data-v-d5efd318>“DSTRZN”</span>. </p><p data-v-d5efd318><span class=\"bolder\" data-v-d5efd318>DIRTY SÖCKS</span> è l&#39;unicità di ogni artista al suo interno che converge, collide, si fonde. </p><p data-v-d5efd318><span class=\"bolder\" data-v-d5efd318>DIRTY SÖCKS</span> è famiglia vera, contaminata e difficile da lavare. </p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationTitle = _resolveComponent("NavigationTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavigationTitle, { class: "subtle" }),
    _createElementVNode("div", {
      class: _normalizeClass(["sub-container", { horizontal: _ctx.mainStore.viewPortConfig.width >= 1000 }]),
      style: _normalizeStyle({
        height: _ctx.mainStore.aboutContainerHeight,
        marginTop: _ctx.mainStore.aboutContainerMargin,
      })
    }, [
      (_ctx.mainStore.viewPortConfig.width >= 1000)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: require(`@/assets/about/collettivo-medium.png`),
            class: "collettivo max"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: require(`@/assets/about/collettivo-small.png`),
            class: "collettivo small",
            style: _normalizeStyle({ height: _ctx.mainStore.collettivoImgHeight })
          }, null, 12, _hoisted_3)),
      _hoisted_4
    ], 6)
  ]))
}